import React, { FC } from 'react'
import { ProductInfoProduct } from '@moonpig/web-shared-products'
import { useStoreId } from '@moonpig/web-core-stores'
import { PeopleAlsoViewedCarousel } from '../../../components/PeopleAlsoViewedCarousel'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'
import { CurveLine } from './CurveLine/CurveLine'

const PEOPLE_ALSO_VIEWED_COUNT = 6

const isProductAvailable = (product: ProductInfoProduct | null): boolean =>
  product !== null && product.masterVariant.inStock

export const PeopleAlsoViewedModule: FC<ProductModule> = props => {
  const [
    {
      product: {
        id,
        peopleAlsoViewed: { products: recommendedProducts },
      },
    },
  ] = useProductContext()

  const region = useStoreId()

  const products = (recommendedProducts?.filter(isProductAvailable) ||
    []) as ProductInfoProduct[]

  return products?.length > 0 ? (
    <>
      <CurveLine bgcolor={props.bgcolor} />
      <ProductModuleSection {...props}>
        <PeopleAlsoViewedCarousel
          parentProductId={id}
          products={products.slice(0, PEOPLE_ALSO_VIEWED_COUNT)}
          region={region}
          carouselIndex={1}
          carouselLength={1}
        />
      </ProductModuleSection>
    </>
  ) : null
}
